var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h5',[_vm._v(_vm._s(_vm.item.question.title))]),_c('div',[(_vm.item.answer.concealed)?_c('div',[_vm._v("\n      Conceal: "+_vm._s(_vm.item.answer.concealed.join(', '))+"\n    ")]):_vm._e(),(_vm.item.answer.flaunted)?_c('div',[_vm._v("\n      Flaunt: "+_vm._s(_vm.item.answer.flaunted.join(', '))+"\n    ")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }